<template>
  <div>
    <div
      style="display: flex; justify-content: space-between; margin-bottom: 20px"
    >
      <div>
        <a-button
          type="ghost"
          shape="round"
          :style="graph.style"
          style="margin-right: 14px"
          @click="changeGraph(graph, graph.disabled)"
          v-for="graph in graphs"
          :key="graph.key"
        >
          <span v-if="graph.disabled">
            <a-popover placement="bottomLeft" trigger="click">
              <template #content>
                <div style="color: darkred; font-weight: bold">
                  Accès limité pour moins de 10 assurés
                </div>
              </template>
              <span v-if="graph.key != '_export'"> {{ graph.name }} </span>
            </a-popover>
          </span>

          <span v-else>
            <span v-if="graph.key != '_export'"> {{ graph.name }} </span>
          </span>
        </a-button>
      </div>

      <div style="text-align: right">
        <strong style="color: forestgreen">{{ info.company?.name }}</strong>
        <div>
          Date d'arrêt des données : <strong>{{ info.updated_at }}</strong>
        </div>
      </div>
    </div>

    <div v-if="true" style="display: flex; justify-content: space-between">
      <div>
        <div>Année</div>
        <a-button
          v-for="year in years"
          type="primary"
          @click="changeYear(year.key)"
          :ghost="year.key != params.year"
          :disabled="year.max_trimester == null"
          :key="year.key"
        >
          {{ year.name }}
        </a-button>
      </div>
      <div>
        <div>Trimestres</div>
        <a-button
          v-for="tr in trimesters"
          type="primary"
          :disabled="tr.disabled"
          @click="changeTrimester(tr.key)"
          :ghost="tr.ghost"
          :key="tr.key"
        >
          {{ tr.name }}
        </a-button>
      </div>
      <div>
        <div>Contrats</div>
        <a-select
          v-model:value="params.contract"
          style="width: 200px"
          :options="contracts"
          @change="changeContract"
        >
        </a-select>
      </div>
      <div>
        <div>Catégories</div>
        <a-select
          v-model:value="params.category"
          style="width: 200px"
          :options="categories"
          @change="changeCategory"
        >
        </a-select>
      </div>
      <div>
        <div>Collèges</div>
        <a-select
          v-model:value="params.college"
          style="width: 200px"
          :options="colleges"
          @change="changeCollege"
        >
        </a-select>
      </div>
    </div>
  </div>
</template>

<script>
import { message } from "ant-design-vue";

export default {
  props: {
    graphsMenu: {
      type: Object,
      required: true,
    },
    params: {
      type: Object,
      required: true,
    },
    menu: {
      type: Object,
      required: true,
    },
    info: {
      type: Object,
      required: true,
    },
    timestamp: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      list_pngs: [],
      exporting: true,
    };
  },
  watch: {
    params: {
      deep: true,
      handler() {
        // this.getClientStat();
      },
    },
  },
  methods: {
    changeGraph(graph, disabled) {
      if (disabled) {
        return;
      }
      // this.params.graph = graph.key;
      this.$router.push(`/graphique/${graph.key}/${this.type}/${this.num}`);
      // this.$emit("get-client-stat", "reload");
    },
    changeYear(yearKey) {
      this.params.year = yearKey;

      let year = this.menu.years.find((y) => y.key == yearKey);

      this.params.trimester = year.max_trimester;
      this.params.contract = this.menu.contracts[0].value;
      this.params.category = "all";
      this.params.college = "all";
      this.$emit("get-client-stat", "reload");
    },
    changeTrimester(trimesterKey) {
      this.params.trimester = trimesterKey;
      this.params.contract = this.menu.contracts[0].value;
      this.params.category = "all";
      this.params.college = "all";
      this.$emit("get-client-stat", "reload");
    },
    changeContract() {
      this.params.category = "all";
      this.params.college = "all";
      this.$emit("get-client-stat");
    },
    changeCategory() {
      this.params.college = "all";
      this.$emit("get-client-stat");
    },
    changeCollege(value) {
      message.destroy();

      // if no data
      if (!!this.menu.colleges.find((c) => c.value == value && c.is_null)) {
        message.config({
          top: "10px",
          duration: 60,
          maxCount: 3,
        });
        message.error("Ces données ne peuvent être communiquées au vu du nombre d’assurés");

        return;
      }

      this.$emit("get-client-stat");
    },
  },
  computed: {
    graphs() {
      return this.graphsMenu?.filter((g) => {
        g.style = {
          color: "black",
        };

        if (g.key === "pop" && this.params.graph == "pop") {
          g.style.backgroundColor = "teal";
          g.style.borderColor = "teal";
          g.style.color = "white";
        }
        if (g.key === "sin" && this.params.graph == "sin") {
          g.style.backgroundColor = "brown";
          g.style.borderColor = "brown";
          g.style.color = "white";
        }
        if (g.key === "coti" && this.params.graph == "coti") {
          g.style.backgroundColor = "#ff5722";
          g.style.borderColor = "#ff5722";
          g.style.color = "white";
        }

        if (g.key === "export" && this.params.graph == "export") {
          g.style.backgroundColor = "teal";
          g.style.borderColor = "teal";
          g.style.color = "white";
        }
        if (g.key === "export") {
          g.style.marginLeft = "20px";
        }

        return g;
      });
      return {};
    },
    graph() {
      return this.$route.params.graph;
    },
    type() {
      return this.$route.params.type;
    },
    num() {
      return this.$route.params.num;
    },
    years() {
      return this.menu?.years;
    },
    trimesters() {
      return this.menu?.trimesters;
    },
    contracts() {
      return this.menu?.contracts;
    },
    categories() {
      return this.menu?.categories;
    },
    colleges() {
      return this.menu.colleges;
    },
    isGraph() {
      return true;
    },
    isExportMode() {
      return this.params.graph === "export";
    },
  },
};
</script>

<style scoped>
div#g_menu {
  display: flex;
  justify-content: space-between;
}
</style>


